/**
 * Registers the PWA service worker (public/sw.js).
 *
 * Production only — in dev a service worker would cache across HMR reloads and
 * cause confusing stale-state bugs. Registration failure is non-fatal: the app
 * runs fine without it, you just lose installability and the offline fallback.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
  });
}
